import { render, staticRenderFns } from "./GenelTalepHesapKimeAitAlacakliRadio.vue?vue&type=template&id=d0389742"
import script from "./GenelTalepHesapKimeAitAlacakliRadio.vue?vue&type=script&lang=ts"
export * from "./GenelTalepHesapKimeAitAlacakliRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports